import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { CREATE_DMX_DEVICE_PRESET } from './actionTypes';
import { createDmxDevicePresetSuccessful, createDmxDevicePresetFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* createDevicePreset({ payload: { preset } }) {
  try {
    const response = yield call(dmxAPI.createDevicePreset, preset.token, preset.deviceId, preset);
    if (response.message) {
      yield put(createDmxDevicePresetSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createDmxDevicePresetFailed(error));
  }
}

export function* watchCreateDmxDevicePreset() {
  yield takeEvery(CREATE_DMX_DEVICE_PRESET, createDevicePreset);
}

function* createDmxDevicePresetSaga() {
  yield all([fork(watchCreateDmxDevicePreset)]);
}

export default createDmxDevicePresetSaga;
